import { render, staticRenderFns } from "./ValidationTemplate.vue?vue&type=template&id=081f02ae"
import script from "./ValidationTemplate.vue?vue&type=script&lang=js"
export * from "./ValidationTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports